// @flow

import * as React from 'react'
import ClassNames from 'classnames'

import type {ToggleOpt} from '../types'

type Props = {
  +onToggle: () => void,
  +optL: ToggleOpt,
  +optR: ToggleOpt,
  selected: any,
}

const Toggle = ({optL, optR, onToggle, selected}: Props) => {
  const className = ClassNames(
    'toggle',
    {'active-l': selected === optL.value},
    {'active-r': selected === optR.value}
  )
  return (
    <div className={className} onClick={() => onToggle()}>
      <span className="label-l">{optL.label}</span>
      <div className="ui">
        <div className="handle" />
      </div>
      <span className="label-r">{optR.label}</span>
    </div>
  )
}

export default Toggle
